import {
    MailGroupFolderRouteParameters,
    ensureValidGroupSmtpAddress,
} from './utils/mailGroupRouteSettings';
import { lazySelectGroup, lazySelectGroupFolder } from 'owa-mail-folder-forest-actions';
import {
    lazyGroupHeaderCommandBarAction,
    lazyGroupHeaderNavigationButton,
} from 'owa-group-header-actions';
import selectRow from './selectRow';
import { getGroupFolderId } from 'owa-group-left-nav-folders-store';
import {
    lazyLoadGroupFolders,
    lazyToggleGroupListNodeExpansion,
} from 'owa-group-folder-tree-actions';
import { GroupFolderWellKnownName, GROUPS_FOLDERS_TREE_TYPE } from 'owa-folders-constants';

export default async function mailGroupFolderRouteHandler(
    parameters: MailGroupFolderRouteParameters
) {
    const groupSmtp = ensureValidGroupSmtpAddress(parameters);
    if (!groupSmtp) {
        return;
    }

    await lazySelectGroup.importAndExecute(groupSmtp, GROUPS_FOLDERS_TREE_TYPE);

    await lazyLoadGroupFolders.importAndExecute(groupSmtp);

    let folderId = null;
    switch (parameters.folderId) {
        case GroupFolderWellKnownName.INBOX:
        case GroupFolderWellKnownName.DELETEDITEMS:
            folderId = getGroupFolderId(groupSmtp, parameters.folderId);
            break;
        default:
            folderId = parameters.folderId;
    }

    const commandBarAction = await lazyGroupHeaderCommandBarAction.import();
    const groupHeaderNavigationButton = await lazyGroupHeaderNavigationButton.import();

    lazySelectGroupFolder.importAndExecute(groupSmtp, folderId, 'groupFolderTree');
    lazyToggleGroupListNodeExpansion.importAndExecute(groupSmtp);
    commandBarAction(groupHeaderNavigationButton.Email);
}

export async function mailGroupFolderRowRouteHandler(parameters: MailGroupFolderRouteParameters) {
    await mailGroupFolderRouteHandler(parameters);

    if (parameters.rowId) {
        selectRow(parameters.rowId);
    }
}
